import { fr } from '@codegouvfr/react-dsfr';
import { useCheckIfNdaExistsBySirenQuery } from '@common/services';
import React from 'react';

export const CheckedNda = ({ siren, nda }: CheckedNdaProps) => {
  const { error: ndaError, isLoading: isNdaLoading } = useCheckIfNdaExistsBySirenQuery({
    siren,
    code: nda,
  }, { skip: !nda });

  return (
    <div className={'flex gap-2'}>
      {(nda) ? (
        <>
          {(ndaError) && <i className={fr.cx('fr-icon-success-fill') + ' text-orange-400'} />}
          {(!isNdaLoading && !ndaError) && <i className={fr.cx('fr-icon-success-fill') + ' color-primary'} />}
          <span>{nda}</span>
        </>
      ) : (
        <i className={fr.cx('fr-icon-warning-fill') + ' text-red-500'} />
      )}
    </div>
  );
};

interface CheckedNdaProps {
  siren: string;
  nda?: string;
}